"use strict";

import { Container3D } from "./containers/container3D.js";

export class ObjectHelper {
    static createRotationContainer(shell) {
        const rotationContainer = new Container3D({ parent: shell });
        shell.setRotationX = (x) => rotationContainer.setRotationX(-x);
        shell.setRotationZ = (z) => rotationContainer.setRotationZ(-z);
        shell.getRotationX = () => -rotationContainer.getRotationX();
        shell.getRotationZ = () => -rotationContainer.getRotationZ();
        shell.getRotation = () => {
            return {
                x: shell.getRotationX(),
                y: shell.getRotationY(),
                z: shell.getRotationZ()
            };
        };
        return rotationContainer;
    }
}